import { Checkbox } from '@affine/component';
import { noop } from 'es-toolkit';
import { useCallback, useContext } from 'react';

import { managerContext } from '../../common';
import * as commonStyles from '../styles.css';
import type { PropertyRowValueProps } from '../types';
import * as styles from './checkbox.css';

export const CheckboxValue = ({ property }: PropertyRowValueProps) => {
  const manager = useContext(managerContext);
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      manager.updateCustomProperty(property.id, {
        value: !property.value,
      });
    },
    [manager, property.id, property.value]
  );
  return (
    <div
      onClick={handleClick}
      className={commonStyles.propertyRowValueCell}
      data-empty={!property.value}
    >
      <Checkbox
        className={styles.checkboxProperty}
        checked={!!property.value}
        onChange={noop}
      />
    </div>
  );
};
